import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'FormGroup',
  props: {
    label: null,
    narrow: {
      type: Boolean
    },
    labelLeft: {
      type: Boolean
    },
    reversed: {
      type: Boolean
    },
    valueWidthRatio: {
      default: 3 / 5
    },
    vertical: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["form-group flex-center", {
          'py-1': !__props.narrow,
          vertical: __props.vertical,
          reversed: __props.reversed
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["mr-2 flex text-ellipsis truncate", {
          'justify-end': !__props.labelLeft,
          'font-bold': __props.reversed
        }]),
        style: _normalizeStyle({
          width: `${(1 - __props.valueWidthRatio) * 100}%`
        })
      }, [!__props.reversed ? _renderSlot(_ctx.$slots, "label", {
        key: 0
      }, () => [_createTextVNode(_toDisplayString(__props.label), 1)]) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })], 6), _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", {
          'font-bold': !__props.reversed
        }]),
        style: _normalizeStyle({
          width: `${__props.valueWidthRatio * 100}%`
        })
      }, [!__props.reversed ? _renderSlot(_ctx.$slots, "default", {
        key: 0
      }) : _renderSlot(_ctx.$slots, "label", {
        key: 1
      }, () => [_createTextVNode(_toDisplayString(__props.label), 1)])], 6)], 2);
    };
  }
});